<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="detail_nomenu">
					<div class="title-00">
						<h1 class="fl">{{titleName}}</h1>
						<div class="clear"></div>
					</div>
					<div class="erji-content">
						<div class="danpian">
							<div class="danpian-h1">{{content.title}}</div>
							<div class="danpian-h2">
								作者：{{content.author}} &nbsp 发布时间：{{content.created_at.slice(0,10)}} &nbsp 浏览量：{{content.hit}}</div>
							<div class="danpian-con" v-html="content.body">
							</div>
							<div class="dan-page">
								<div class="dan-a" v-if="this.prev_title != ''">
									<div class="dan-a_span" @click="go_pnLink(prev_id)">上一篇：{{prev_title}}</div>
								</div>
								<div class="dan-a" v-if="this.next_title != ''">
									<div class="dan-a_span" @click="go_pnLink(next_id)">下一篇：{{next_title}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'detail_nomenu',
		data(){
			return{
				childId:'',
				titleName:'',
				id:'',
				category_id:'',
				content:{
					author:'',
					created_at:'',
					hit:'',
					body:''
				},
				prev_title:"",
				prev_id:"",
				next_title:"",
				next_id:"",
			}
		},
		methods:{
			//请求分类信息
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求详情
			res_detail(){
				this.axios.get('/api/news/newsView?id='+this.id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							console.log('response050',response)
							this.content = response.data.reslut;
							this.content.body = response.data.reslut.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.icoURL}/${path}' />`
										: match;
								}
							);
							this.id = response.data.reslut.id;
							this.prev_id = response.data.reslut.pre_id;
							this.next_id = response.data.reslut.next_id;
							this.res_detail_p()
							this.res_detail_n()
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求兄弟内容
			res_detail_p(){
				this.axios.get('/api/news/newsView?id='+this.prev_id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log(response.data.reslut)
							this.prev_title = response.data.reslut.title;
						}else{
							this.prev_title = ''
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_detail_n(){
				this.axios.get('/api/news/newsView?id='+this.next_id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log(response.data.reslut)
							this.next_title = response.data.reslut.title;
						}else{
							this.next_title = ''
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//跳转兄弟链接
			go_pnLink(e){
				$('html, body').animate({ scrollTop: 0 }, 0);
			
				console.log("333",e)
				if(e){
					this.$router.push({
						path:'/detail_nomenu',
						query:{
							category_id:this.content.category_id,
							id:e
						}
					})	
					console.log('===')
				}else{
					console.log('???')
				}
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.category_id = this.$route.query.category_id
			this.res_detail();
			this.res_menusClass(this.category_id)
			
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					// console.log("to",to);
					// console.log("from",from);
					this.id = to.query.id;
					this.prev_title= "";
					this.next_title= "";
					this.res_detail(this.id);
			}
		},
		mounted(){
		
		}
	}
</script>

<style>
</style>